import { Grid, Card, CardContent, CardActions } from '@mui/material';
import { CerebroText } from '../../../shared/components';
import { CurrentUser, DataRoom, DealPartnerContact, UnlockUser } from '../../../shared/models';
import { DataRoomPartnerContactActionButton } from './DataRoomPartnerContactActionButton';

interface DataRoomPartnerContactItemProps {
	dataRoom: DataRoom;
	contact: DealPartnerContact;
	currentUser: CurrentUser | null;
	unlockUser: (unlockUser: UnlockUser) => void;
	removeAccess: (contact: DealPartnerContact) => void;
	sendAccountInfo: (contact: DealPartnerContact) => void;
}

export const DataRoomPartnerContactItem: React.FC<DataRoomPartnerContactItemProps> = ({
	dataRoom,
	contact,
	currentUser,
	unlockUser,
	removeAccess,
	sendAccountInfo
}) => {
	return (
		<Grid key={contact.guid} item xs={12}>
			<Card
				elevation={3}
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					flexDirection: 'column',
					height: '100%',
					marginBottom: 2,
				}}
			>
				<CardContent sx={{ paddingBottom: '0 !important' }}>
					<Grid container sx={{ marginBottom: 2 }}>
						<Grid item xs={12}>
							<CerebroText variant="large" component="span" sx={{ fontWeight: 'bold' }}>
								{contact?.firstName} {contact?.lastName}
							</CerebroText>
						</Grid>
                        <CerebroText gutterBottom sx={{ marginTop: 1 }}>
						    {contact?.emailAddress}
					    </CerebroText>
					</Grid>
				</CardContent>
				<CardActions
					sx={theme => ({
						alignItems: 'flex-end',
						backgroundColor: theme.palette.gray.background,
						borderTop: `1px solid ${theme.palette.divider}`,
						justifyContent: 'right',
					})}
				>
					<Grid container>
						<Grid item xs={12} sx={{ textAlign: 'right' }}>
							<DataRoomPartnerContactActionButton
								dataRoom={dataRoom}
								contact={contact}
								currentUser={currentUser}
								unlockUser={unlockUser}
								removeAccess={removeAccess}
								sendAccountInfo={sendAccountInfo}
							/>
						</Grid>
					</Grid>
				</CardActions>
			</Card>
		</Grid>
	);
};
